import React from 'react';
import { countryCodeToEmoji } from '../../../utils/countryUtils';

const NodeForm = ({ formData, onChange, mode = 'create' }) => {
  const handleFieldChange = (field, value) => {
    if (field === 'flag') {
      onChange(field, countryCodeToEmoji(value));
    } else if (field === 'port' || field === 'ssh_port') {
      onChange(field, parseInt(value) || 0);
    } else {
      onChange(field, value);
    }
  };

  const title = mode === 'create' ? 'Добавить новую ноду' : 'Редактировать ноду';
  const submitText = mode === 'create' ? 'Создать ноду' : 'Сохранить изменения';

  return (
    <form className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-dark-300 mb-1">
          Название ноды
        </label>
        <input
          type="text"
          required
          value={formData.name}
          onChange={(e) => handleFieldChange('name', e.target.value)}
          className="w-full px-3 py-2.5 bg-gray-50 dark:bg-dark-950 border border-gray-200 dark:border-dark-800 rounded-lg text-gray-900 dark:text-white focus:outline-none focus:border-primary-500 transition-colors"
          placeholder="например, Японская нода"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-dark-300 mb-1">
          Локация
        </label>
        <input
          type="text"
          required
          value={formData.location}
          onChange={(e) => handleFieldChange('location', e.target.value)}
          className="w-full px-3 py-2.5 bg-gray-50 dark:bg-dark-950 border border-gray-200 dark:border-dark-800 rounded-lg text-gray-900 dark:text-white focus:outline-none focus:border-primary-500 transition-colors"
          placeholder="например, Япония"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-dark-300 mb-1">
          Флаг
        </label>
        <input
          type="text"
          required
          value={formData.flag}
          onChange={(e) => handleFieldChange('flag', e.target.value)}
          className="w-full px-3 py-2.5 bg-gray-50 dark:bg-dark-950 border border-gray-200 dark:border-dark-800 rounded-lg text-gray-900 dark:text-white focus:outline-none focus:border-primary-500 transition-colors"
          placeholder="🇯🇵, JP, japan, япония и т.д."
        />
        <p className="text-xs text-gray-500 dark:text-dark-500 mt-1">
          Вы можете указать эмодзи (🇯🇵), код страны (JP, ua, UA), название (Japan, ukraína, япония)
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-dark-300 mb-1">
          Хост (IP или домен)
        </label>
        <input
          type="text"
          required
          value={formData.host}
          onChange={(e) => handleFieldChange('host', e.target.value)}
          className="w-full px-3 py-2.5 bg-gray-50 dark:bg-dark-950 border border-gray-200 dark:border-dark-800 rounded-lg text-gray-900 dark:text-white focus:outline-none focus:border-primary-500 transition-colors"
          placeholder="например, 192.168.1.100"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-dark-300 mb-1">
            Порт
          </label>
          <input
            type="number"
            required
            value={formData.port}
            onChange={(e) => handleFieldChange('port', e.target.value)}
            className="w-full px-3 py-2.5 bg-gray-50 dark:bg-dark-950 border border-gray-200 dark:border-dark-800 rounded-lg text-gray-900 dark:text-white focus:outline-none focus:border-primary-500 transition-colors"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-dark-300 mb-1">
          SSH пользователь
        </label>
        <input
          type="text"
          required
          value={formData.ssh_user}
          onChange={(e) => handleFieldChange('ssh_user', e.target.value)}
          className="w-full px-3 py-2.5 bg-gray-50 dark:bg-dark-950 border border-gray-200 dark:border-dark-800 rounded-lg text-gray-900 dark:text-white focus:outline-none focus:border-primary-500 transition-colors"
          placeholder="например, root"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-dark-300 mb-1">
          SSH порт
        </label>
        <input
          type="number"
          required
          value={formData.ssh_port}
          onChange={(e) => handleFieldChange('ssh_port', e.target.value)}
          className="w-full px-3 py-2.5 bg-gray-50 dark:bg-dark-950 border border-gray-200 dark:border-dark-800 rounded-lg text-gray-900 dark:text-white focus:outline-none focus:border-primary-500 transition-colors"
        />
      </div>
    </form>
  );
};

export default NodeForm;